import {computed, inject, Injectable} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Router} from '@angular/router';
import {authConfig} from './auth.config';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly router = inject(Router);
  
  // Extract postLoginRoute from config
  private readonly postLoginRoute = (() => {
    const config = authConfig.config;
    if (Array.isArray(config)) {
      return config[0]?.postLoginRoute || '/sync';
    }
    return config?.postLoginRoute || '/sync';
  })();

  private userData = this.oidcSecurityService.userData;
  private authenticated = this.oidcSecurityService.authenticated;

  signedIn = computed(() => {
    return this.authenticated().isAuthenticated;
  });

  getUserData() {
    return this.userData().userData;
  }

  login(): void {
    this.oidcSecurityService.authorize();
  }

  logout(): void {
    this.oidcSecurityService.logoff()
      .subscribe((result) => console.log(result));
  }

  checkAuth(): void {
    this.oidcSecurityService.checkAuth().subscribe((loginResponse) => {
      // Handle post-login routing when authentication is successful
      if (loginResponse.isAuthenticated && loginResponse.userData) {
        // Only redirect if we're on the home page (coming from external auth)
        if (window.location.pathname === '/' || window.location.pathname === '/home') {
          // Redirect using configured postLoginRoute
          this.router.navigate([this.postLoginRoute]);
        }
      }
    });
  }

  getUserName(): string {
    if (!this.signedIn()) {
      return '';
    }
    const nameMatch = this.getUserData().email.match(/^([^@]*)@/);
    return nameMatch ? nameMatch[1] : '';
  }

  getLoginInfo() : string {
    if (!this.signedIn()) {
      return "";
    }
    const userData = this.getUserData();
    if (userData.given_name) {
      let displayInfo = userData.given_name;
      displayInfo += (userData.family_name) ? " " + userData.family_name.substring(0, 1) : "";
      return displayInfo;
    }
    return this.getUserName();
  }
}
